<template>
  <div class="dashboard main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Painel de Controle</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col>
            <label class="cj-label">Período</label>
            <date-range-picker
              class="w-100"
              ref="picker"
              :opens="'right'"
              :ranges="false"
              :localeData="dateRangePickerPtBrLocale"
              :showDropdowns="true"
              v-model="dashboardForm.dateTime">
              <div slot="input" slot-scope="picker" class="">
                {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
              </div>
            </date-range-picker>
          </b-col>
          <b-col>
            <label class="cj-label">Agenda</label>
            <multiselect v-model="dashboardForm.agenda" :options="agendas" track-by="name" label="name" :showLabels="false" placeholder="Selecione"></multiselect>
          </b-col>
          <b-col>
            <label class="cj-label">Profissional</label>
            <multiselect v-model="dashboardForm.professional" :options="professionals" track-by="name" label="name" :showLabels="false" placeholder="Selecione"></multiselect>
          </b-col>
          <b-col>
            <label class="cj-label">Método de agendamento</label>
            <multiselect v-model="dashboardForm.channel" :options="channels" track-by="name" label="name" :showLabels="false" placeholder="Selecione"></multiselect>
          </b-col>
          <b-col>
            <label class="cj-label w-100">&nbsp;</label>
            <b-button variant="primary" block @click="getDashboard"><i class="far fa-search"></i> Filtrar</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12" class="text-right">
            <b-button size="sm" variant="primary" @click="exportItems()"><i class="far fa-download"></i> Exportar consultas</b-button>
          </b-col>
        </b-row>

        <b-row class="header-info">
          <b-col cols="12">
            <div class="box-cj">
              <b-row class="mb-0">
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setStatusSelected('scheduled')">
                    <p class="info mb-2">Consultas agendadas</p>
                    <p :class="'value ' + (statusSelected == 'scheduled' ? 'active' : '')">{{ dashboardData.appointmentsScheduled.length }}</p>
                  </div>
                </b-col>
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setStatusSelected('showedup')">
                    <p class="info mb-2">Consultas atendidas</p>
                    <p :class="'value ' + (statusSelected == 'showedup' ? 'active' : '')">{{ dashboardData.appointmentsShowedUp.length }}</p>
                  </div>
                </b-col>
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setStatusSelected('canceled')">
                    <p class="info mb-2">Consultas canceladas</p>
                    <p :class="'value ' + (statusSelected == 'canceled' ? 'active' : '')">{{ dashboardData.appointmentsCanceled.length }}</p>
                  </div>
                </b-col>
                <b-col class="p-4 text-center">
                  <div class="pointer" @click="setStatusSelected('missed')">
                    <p class="info mb-2">Não compareceram</p>
                    <p :class="'value ' + (statusSelected == 'missed' ? 'active' : '')">{{ dashboardData.appointmentsMissed.length }}</p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="statusSelected != null">
          <b-col>
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">{{ getInfoBySelectedStatus('title') }}</p>

                  <div>
                    <i class="far fa-times pointer" @click="setStatusSelected(null)"></i>
                  </div>
                </div>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Data / Hora</th>
                      <th>Profissional</th>
                      <th>Paciente</th>
                      <th>Convênio</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="appointment in getInfoBySelectedStatus('data')" :key="appointment.id">
                      <td class="align-middle">{{ moment(appointment.start_datetime).format('DD/MM HH:mm') }}</td>
                      <td class="align-middle">{{ appointment.professional.name }}</td>
                      <td class="align-middle">
                        {{ appointment.patient.name }}<br/>
                        <small>
                          {{ appointment.patient.cellphone }}
                        </small>
                      </td>
                      <td class="align-middle">
                        {{ appointment.health_plan.name }}<br/>
                        <small v-if="appointment.paid_invoice != null">
                          <router-link v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR'" target="_blank" tag="a" :to="'/financeiro/transacoes/'+appointment.paid_invoice.id">PG ONLINE</router-link>
                          <span v-else>PG ONLINE</span>
                        </small>
                      </td>
                      <td class="align-middle" v-html="getStatusTag(appointment.status)"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <div class="box-cj">
              <div class="header">
                Convênios Atendidos
              </div>
              <div class="content p-0">
                <GChart
                  type="PieChart"
                  :data="dashboardData.appointmentsByHealthPlan"
                  :options="{ chartArea: { top: 15 }, legend: { alignment: 'center', position: 'bottom', textStyle: { color: '#212C3B', bold: true } }, is3D: true }"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="box-cj">
              <div class="header">
                Horários de Pico
              </div>
              <div class="content p-0">
                <GChart
                  type="ColumnChart"
                  :data="dashboardData.appointmentsByHour"
                  :options="{ chartArea: { top: 15 }, legend: { alignment: 'center', position: 'bottom', textStyle: { color: '#212C3B', bold: true } } }"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canManage: true,

        dashboardForm: {
          dateTime: { startDate: this.moment().startOf('week'), endDate: this.moment().endOf('week') },
          agenda: { value: null, name: 'Todas' },
          professional: { value: null, name: 'Todos' },
          channel: { value: null, name: 'Todos' },
        },

        dashboardData: {
          appointmentsScheduled: [],
          appointmentsShowedUp: [],
          appointmentsCanceled: [],
          appointmentsMissed: [],
          appointmentsByHealthPlan: [],
          appointmentsByHour: []
        },

        statusSelected: null,

        agendas: [],
        professionals: [],

        channels: [
          { value: null, name: 'Todos' },
          { value: 'internal', name: 'Agendamentos internos' },
          { value: 'online', name: 'Agendamentos online' }
        ],

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort(),
        },
      }
    },
    async mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('dashboard', 'can_see');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission('dashboard', 'can_manage');

      await this.api.getAgendas({}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.agendas = [{ value: null, name: 'Todas' }];
        res.data.forEach(agenda => {
          this.agendas.push({ value: agenda.id, name: agenda.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Agendas', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as suas agendas! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Agendas', err.response);
      });

      await this.api.getPeople({type: 'PROFESSIONAL'}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.professionals = [{ value: null, name: 'Todos' }];
        res.data.data.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Professional', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os profissionais da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Professional', err.response);
      });

      this.getDashboard();
    },
    methods: {
      async getDashboard() {
        this.eventBus.$emit('IS_LOADING', true);
        let dashboardData = {
          start_date: this.moment(this.dashboardForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.dashboardForm.dateTime.endDate).format('YYYY-MM-DD'),
          agenda: (this.dashboardForm.agenda != null && this.dashboardForm.agenda.hasOwnProperty('value'))?this.dashboardForm.agenda.value:null,
          professional: (this.dashboardForm.professional != null && this.dashboardForm.professional.hasOwnProperty('value'))?this.dashboardForm.professional.value:null,
          channel: (this.dashboardForm.channel != null ? this.dashboardForm.channel.value:null)
        };

        await this.api.getDashboard(dashboardData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.dashboardData = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Dashboard', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          this.$swal('Ops...', 'Não conseguimos carregar os dados do consultório! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Dashboard', err.response);
        });
      },
      setStatusSelected(status) {
        this.statusSelected = status;
      },
      getInfoBySelectedStatus(type) {
        let title = '';
        let data = [];
        switch (this.statusSelected) {
          case 'scheduled':
            title = 'Agendamentos realizados';
            data = this.dashboardData.appointmentsScheduled;
            break;
          case 'showedup':
            title = 'Agendamentos comparecidos';
            data = this.dashboardData.appointmentsShowedUp;
            break;
          case 'canceled':
            title = 'Agendamentos cancelados';
            data = this.dashboardData.appointmentsCanceled;
            break;
          case 'missed':
            title = 'Agendamentos não comparecidos';
            data = this.dashboardData.appointmentsMissed;
            break;
        }

        return (type == 'title')?title:data;
      },
      getStatusTag(status) {
        let color = '';
        let text = '';
        switch (status) {
          case 'SCHEDULED':
            color = '#0F94D8';
            text = 'Agendado';
          break;
          case 'CONFIRMED':
            color = '#28CD6A';
            text = 'Confirmado';
          break;
          case 'CANCELED':
            color = '#CC3F42';
            text = 'Cancelado';
          break;
          case 'MISSED':
            color = '#F5A834';
            text = 'Faltou';
          break;
          case 'SHOWEDUP':
            color = '#674BD0';
            text = 'Compareceu';
          break;
          case 'ATTENDED':
            color = '#C9D5DB';
            text = 'Atendido';
          break;
        }

        return '<span class="tag" style="background-color: '+color+';">'+text+'</span>';
      },

      exportItems() {
        this.eventBus.$emit('IS_LOADING', true);
        let dashboardData = {
          start_date: this.moment(this.dashboardForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.dashboardForm.dateTime.endDate).format('YYYY-MM-DD'),
          agenda: (this.dashboardForm.agenda != null && this.dashboardForm.agenda.hasOwnProperty('value'))?this.dashboardForm.agenda.value:null,
          professional: (this.dashboardForm.professional != null && this.dashboardForm.professional.hasOwnProperty('value'))?this.dashboardForm.professional.value:null,
          channel: (this.dashboardForm.channel != null ? this.dashboardForm.channel.value:null)
        };
        this.api.exportDashboardData(dashboardData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          var type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              blob = new Blob([res.data], { type: type }),
              anchor = document.createElement('a');

          anchor.download = 'consultas.xlsx';
          anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
          anchor.dataset.downloadurl = [type, anchor.download, anchor.href].join(':');
          anchor.click();

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Export Dashboard Data', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos exportar as consultas da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Export Dashboard Data', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .dashboard {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;

        &.active {
          color: $curiousBlue;
        }
      }
    }

    .tag {
      width: 100%;
      padding: 5px 15px;
      color: #ffffff;
      border-radius: 15px;
    }

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }
        }
      }
    }
  }
</style>
